import React from "react";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { ProblemSolution } from "../components/site/ProblemSolution";
import { HowItWorks } from "../components/site/HowItWorks";
import { VideoShowcase } from "../components/site/VideoShowcase";
import { ProductLines } from "../components/site/ProductLines";
import { Products } from "../components/site/Products";
import { KitsSection } from "../components/site/KitsSection";
import { TargetClients } from "../components/site/TargetClients";
import { Differentiators } from "../components/site/Differentiators";
import { BusinessOpportunity } from "../components/site/BusinessOpportunity";
import { Partnership } from "../components/site/Partnership";
import { Testimonials } from "../components/site/Testimonials";
import { FAQ } from "../components/site/FAQ";
import { LeadForm } from "../components/site/LeadForm";
import { Footer } from "../components/site/Footer";
import { WhatsAppButton } from "../components/site/WhatsAppButton";
import { CartDrawer } from "../components/site/CartDrawer";
import { Reveal } from "../components/site/Reveal";

export default function Home() {
    return (
        <div data-testid="home-page">
            <Header />
            <main>
                <Hero />
                <Reveal>
                    <ProblemSolution />
                </Reveal>
                <Reveal>
                    <HowItWorks />
                </Reveal>
                <Reveal>
                    <VideoShowcase />
                </Reveal>
                <Reveal>
                    <ProductLines />
                </Reveal>
                <Reveal>
                    <TargetClients />
                </Reveal>
                <Reveal>
                    <Products />
                </Reveal>
                <Reveal>
                    <Testimonials />
                </Reveal>
                <Reveal>
                    <KitsSection />
                </Reveal>
                <Reveal>
                    <Differentiators />
                </Reveal>
                <Reveal>
                    <BusinessOpportunity />
                </Reveal>
                <Reveal>
                    <Partnership />
                </Reveal>
                <Reveal>
                    <FAQ />
                </Reveal>
                <Reveal>
                    <LeadForm />
                </Reveal>
            </main>
            <Footer />
            <WhatsAppButton />
            <CartDrawer />
        </div>
    );
}
